export default "__VITE_PUBLIC_ASSET__e440e528__"